(() => {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#PrimaryNav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  }

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-card-url]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, select, textarea, form')) return;
      const url = card.getAttribute('data-card-url');
      if (url) window.location.href = url;
    });
  });

  const money = (cents) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'GBP'
  }).format(cents / 100);

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const cartDrawer = document.querySelector('#CartDrawer');
  const cartContent = cartDrawer?.querySelector('[data-cart-drawer-content]');
  const cartFooter = cartDrawer?.querySelector('[data-cart-drawer-footer]');
  const cartTotal = cartDrawer?.querySelector('[data-cart-drawer-total]');
  const rootPath = window.Shopify?.routes?.root || '/';
  let cartOpener = null;

  const updateCartCount = (count) => {
    const cartLink = document.querySelector('.cart-link');
    if (!cartLink) return;
    let badge = cartLink.querySelector('.cart-link__count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'cart-link__count';
      cartLink.append(' ', badge);
    }
    if (badge) {
      badge.textContent = count;
      if (count === 0) badge.remove();
    }
  };

  const renderCart = (cart) => {
    if (!cartContent || !cartFooter || !cartTotal) return;
    updateCartCount(cart.item_count);
    if (!cart.item_count) {
      cartContent.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is currently empty.</p><a class="button" href="/collections/all">Shop The Core Four</a></div>';
      cartFooter.hidden = true;
      return;
    }
    cartContent.innerHTML = cart.items.map((item, index) => `
      <article class="cart-drawer__item">
        ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="82" height="96">` : ''}
        <div>
          <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.selling_plan_allocation ? `<p>${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</p>` : '<p>One-off purchase</p>'}
          <p><strong>${money(item.final_line_price)}</strong></p>
        </div>
        <div class="cart-drawer__item-controls">
          <div class="cart-drawer__quantity" aria-label="Quantity for ${escapeHtml(item.product_title)}">
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-change data-line="${index + 1}" data-quantity="0">Remove</button>
        </div>
      </article>
    `).join('');
    cartTotal.textContent = money(cart.total_price);
    cartFooter.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const openCart = async (opener) => {
    if (!cartDrawer) return;
    cartOpener = opener || document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    try {
      await fetchCart();
    } catch (error) {
      if (cartContent) cartContent.innerHTML = '<p class="cart-drawer__error">We could not load your cart. Please use the cart page instead.</p>';
    }
    cartDrawer.querySelector('[data-cart-close]')?.focus();
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    cartOpener?.focus?.();
  };

  cartDrawer?.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-close]')) {
      closeCart();
      return;
    }
    const changeButton = event.target.closest('[data-cart-change]');
    if (!changeButton) return;
    changeButton.disabled = true;
    try {
      const response = await fetch(`${rootPath}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(changeButton.dataset.line), quantity: Number(changeButton.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Unable to update cart');
      renderCart(await response.json());
    } catch (error) {
      changeButton.disabled = false;
    }
  });

  document.querySelector('.cart-link')?.addEventListener('click', (event) => {
    if (!cartDrawer) return;
    event.preventDefault();
    openCart(event.currentTarget);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    event.preventDefault();
    const submitButton = event.submitter || form.querySelector('[type="submit"]');
    const originalText = submitButton?.textContent;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
    }
    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add product');
      await openCart(submitButton);
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    }
  });

  const exitOffer = document.querySelector('[data-exit-offer]');
  const exitKey = 'folyx-exit-guide-shown-v1';
  const exitCooldown = 14 * 24 * 60 * 60 * 1000;
  const pageOpenedAt = Date.now();
  let mobileExitReady = false;

  const exitRecentlyShown = () => {
    try {
      return Date.now() - Number(localStorage.getItem(exitKey) || 0) < exitCooldown;
    } catch (error) {
      return false;
    }
  };

  const openExitOffer = () => {
    if (!exitOffer || exitOffer.classList.contains('is-open') || exitRecentlyShown()) return;
    exitOffer.classList.add('is-open');
    exitOffer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    try { localStorage.setItem(exitKey, String(Date.now())); } catch (error) {}
    exitOffer.querySelector('input[type="email"]')?.focus();
  };

  const closeExitOffer = () => {
    if (!exitOffer) return;
    exitOffer.classList.remove('is-open');
    exitOffer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  };

  exitOffer?.addEventListener('click', (event) => {
    if (event.target.closest('[data-exit-close]')) closeExitOffer();
  });

  document.addEventListener('mouseout', (event) => {
    if (window.innerWidth < 700 || Date.now() - pageOpenedAt < 8000) return;
    if (event.clientY <= 4 && !event.relatedTarget) openExitOffer();
  });

  window.setTimeout(() => { mobileExitReady = true; }, 45000);
  window.addEventListener('scroll', () => {
    if (!mobileExitReady || window.innerWidth >= 700) return;
    const available = document.documentElement.scrollHeight - window.innerHeight;
    if (available > 0 && window.scrollY / available > .55) openExitOffer();
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (exitOffer?.classList.contains('is-open')) closeExitOffer();
    else if (cartDrawer?.classList.contains('is-open')) closeCart();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const frames = [...gallery.querySelectorAll('[data-gallery-frame]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const targetId = thumb.dataset.galleryThumb;
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        frames.forEach((frame) => {
          const active = frame.dataset.galleryFrame === targetId;
          frame.hidden = !active;
          frame.classList.toggle('is-active', active);
          if (!active) frame.querySelector('video')?.pause();
        });
      });
    });
  });

  const productForm = document.querySelector('#ProductForm');
  if (productForm) {
    const variantId = productForm.querySelector('input[name="id"]');
    const price = document.querySelector('[data-product-price]');
    const submit = productForm.querySelector('.sticky-atc-trigger');
    const stickyPrice = document.querySelector('.sticky-atc small');
    productForm.querySelectorAll('[data-variant-choice]').forEach((choice) => {
      choice.addEventListener('change', () => {
        if (!choice.checked) return;
        if (variantId) variantId.value = choice.value;
        if (price) {
          price.innerHTML = choice.dataset.comparePrice
            ? `<span class="price-compare">${choice.dataset.comparePrice}</span><span class="price-current">${choice.dataset.price}</span>`
            : `<span class="price-current">${choice.dataset.price}</span>`;
          price.classList.toggle('product-price--sale', Boolean(choice.dataset.comparePrice));
        }
        if (submit) submit.textContent = `Add to cart · ${choice.dataset.price}`;
        if (stickyPrice) stickyPrice.textContent = choice.dataset.price;
      });
    });
  }
})();
